<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage" @load="loadSummary">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <!-- 平台积分账户余额汇总 -->
                        <div class="stats-bar flex">
                            <div class="stats-card card-orange">
                                <div class="stats-info">
                                    <div class="stats-title-row flex-start-center">
                                        <span class="stats-label">保证金余额</span>
                                        <span class="stats-value">{{formatPrice(balance.deposit_balance)}}</span>
                                    </div>
                                </div>
                                <div class="stats-icon">元</div>
                            </div>
                        </div>

                        <m-search-item label="商户信息" colspan="2">
                            <c-select name="saas_ids" multiple async @search="searchSaas"></c-select>
                        </m-search-item>
                        <m-search-item label="记录单号">
                            <c-input name="record_number"></c-input>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_xiaohei_deposit_record_export')"
                              prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <!--账户类型-->
                <template #account_type="{data}">
                    <c-state tag async dict="ACCOUNT_TYPE" :value="data.account_type"></c-state>
                </template>
                <!--收支类型-->
                <template #income_expenses="{data}">
                    <c-state tag async dict="INCOME_EXPENSES" :value="data.income_expenses"></c-state>
                </template>
                <!--收支状态-->
                <template #trans_state="{data}">
                    <c-state tag async dict="TRANS_STATE" :value="data.trans_state"></c-state>
                </template>
                <!--资金-->
                <template #money="{data}">
                    <span v-if="data.income_expenses == 1" style="color: green">￥+{{data.money}}</span>
                    <span v-if="data.income_expenses == 2" style="color: red">￥{{data.money}}</span>
                </template>
                <!--余额-->
                <template #surplus_money="{data}">
                    ￥{{data.surplus_money}}
                </template>

                <!--汇总统计：后端按当前筛选口径对全量数据聚合（收入累加、支出扣减），与分页无关-->
                <template #foot>
                    <div class="summary-bar flex-start-center">
                        <span class="summary-item">收入合计<span class="summary-value income">{{ incomeText }}</span></span>
                        <span class="summary-item">支出合计<span class="summary-value expense">{{ expenseText }}</span></span>
                        <span class="summary-item">净额<span class="summary-value" :class="netClass">{{ netText }}</span></span>
                    </div>
                </template>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import accountDeduction from "@/pages/finance/saas_account_deduction.vue";

export default {
    name:'p_xiaohei_deposit_record',

    components: {
    },

    data() {
        return {
            workType: 112,
            defaultSearchData: {
                user_type:0,     //默认查询主账号数据
                trans_states:[1,3]  //不展示【2：处理中】的记录
            },
            balance: {
                deposit_balance: 0
            },
            //资金收支汇总（当前筛选口径全局统计，与分页无关）
            summary: {},
            payEnabled:true,
            ids:[],
            withdraw_account_type:0 //账户类型 1=通联账户  2=三方同售账户
        }
    },
    mounted() {
        this.loadBalance();
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo']),
        incomeText() {
            const val = parseFloat(this.summary.income_money);
            return isNaN(val) ? '￥0.00' : '￥' + val.toFixed(2);
        },
        expenseText() {
            const val = parseFloat(this.summary.expense_money);
            return isNaN(val) ? '￥0.00' : '￥' + val.toFixed(2);
        },
        netText() {
            const val = parseFloat(this.summary.net_money);
            if (isNaN(val)) return '￥0.00';
            return (val > 0 ? '+' : '') + '￥' + Math.abs(val).toFixed(2);
        },
        netClass() {
            const val = parseFloat(this.summary.net_money);
            return isNaN(val) || val == 0 ? '' : (val > 0 ? 'income' : 'expense');
        }
    },

    methods: {
        /*******商户异步下拉（值为saas_ids，列表/导出共用 recordListWhere 中 client=2 的 tuar.saas_id in 条件）*****************/
        searchSaas(keyword, resolve) {
            this.request({
                url: '/sys_saas/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /**
         * 加载平台积分账户余额汇总（顶部资金汇总卡片）
         */
        loadBalance() {
            this.request({
                url: '/financial/platform/account/balance',
                data: {},
                success: data => {
                    this.balance = {
                        deposit_balance: data && data.deposit_balance ? data.deposit_balance : 0,
                    };
                }
            });
        },

        /**
         * 累计资金变化统计（与列表同筛选口径，随搜索/视图/分页联动刷新）
         */
        loadSummary(listData, searchParams) {
            this.request({
                url: '/account/record/summary',
                data: Object.assign({}, searchParams),
                success: data => {
                    this.summary = data || {};
                }
            });
        },

        /**
         *格式化（积分无单位换算，直接展示数值）
         */
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        },
    }
}
</script>

<style lang="stylus" scoped>
.summary-bar {
    flex-shrink: 0;
    gap: 32px;
    border-top: 1px solid #F5F5F5;
    padding: 8px 12px;
    font-size: 13px;
    color: #666;

    .summary-item {
        display: inline-flex;
        align-items: baseline;

        .summary-value {
            margin-left: 6px;
            font-size: 16px;
            font-weight: bold;

            &.income {
                color: #67C23A;
            }

            &.expense {
                color: #F56C6C;
            }
        }
    }
}

.stats-bar {
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    border-top: 1px solid #F5F5F5;
    padding: 8px 12px;

    .stats-card {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1 1 260px;
        max-width: 550px;
        min-height: 56px;
        padding: 8px 16px;
        border-radius: 6px;
        color: #fff;
        box-sizing: border-box;
        overflow: hidden;

        &.card-orange {
            background: linear-gradient(90deg, #f97316, #fb923c);
        }

        &.card-green {
            background: linear-gradient(90deg, #16a34a, #22c55e);
        }

        .stats-info {
            position: relative;
            z-index: 1;

            .stats-title-row {
                display: flex;
                align-items: baseline;
                line-height: 24px;

                .stats-label {
                    font-size: 12px;
                    opacity: 0.95;
                }

                .stats-value {
                    margin-left: 6px;
                    font-size: 18px;
                    font-weight: bold;
                }
            }

            .stats-summary-row {
                gap: .5em;
                margin-top: 2px;
                font-size: 11px;

                label {
                    opacity: 0.9;
                }
            }
        }

        .stats-icon {
            position: absolute;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 32px;
            line-height: 1;
            opacity: 0.15;
        }
    }
}
</style>